module.exports = __webpack_public_path__ + "media/page_flipping.93b25891.wav";